export const encodeCollectionIds = (collectionIds: string[]): string => {
	return encodeURIComponent(collectionIds.join(','));
};

export const addCollectionsToUrlParams = (
	url: string,
	collectionIds: string[],
	showOnlyPropertiesInMyCollection: boolean,
	useQuestionMarkAsDelimiter = false,
	isMultipleCollectionsEnabled = false
): string => {
	const delimiter: string = useQuestionMarkAsDelimiter ? '?' : '&';

	// (isMultipleCollectionsEnabled || showOnlyPropertiesInMyCollection) should be removed when multiple collections feature is fully integrated
	if (
		collectionIds.length > 0 &&
		(isMultipleCollectionsEnabled || showOnlyPropertiesInMyCollection)
	) {
		return `${url}${delimiter}collectionIds=${encodeCollectionIds(collectionIds)}`;
	}

	return url;
};
